import { Product } from '../model/product.model';
import { Portion } from '../model/portion.model';
import { Weight } from '../model/weight.model';
import { Energy } from '../model/energy.model';

export const productFactory = {
    create(id, externalId, name, weights, energy, category, allergen, disliked, nutrients, portion = null, patient = null) {

      weights = weights.map((w) => {
        return new Weight(w.amount, w.unit);
      });

      if (portion === null) {
        portion = new Portion(1, weights[0]);
      } else {
        portion = new Portion(portion.amount, new Weight(portion.weight.amount, portion.weight.unit));
      }

      if (patient) {
        allergen = patient.hasAllergyForProduct(externalId);
        disliked = patient.dislikesProduct(externalId);
      }

      return new Product(
        id,
        externalId,
        name,
        weights,
        new Energy(energy),
        category,
        allergen,
        disliked,
        Object.freeze(nutrients),
        portion,
      );
    },
    createFromDto(productDto, patient = null) {

      return this.create(
        productDto.id,
        productDto.externalId,
        productDto.name,
        productDto.weight,
        productDto.energy.amount,
        productDto.category,
        productDto.allergen,
        productDto.disliked,
        productDto.nutrients,
        productDto.portion,
        patient,
      );
    },
  }
;
